import { PlanConfig } from './plan-config'
import { PlanHighlights } from './plan-highlights'
import { PlanSelectionCardProps } from './types'

export const PlanSelectionCard = ({
	selectedPlan,
	plans,
	adSpend,
	onAdSpendChange,
	onPlanChange,
	onCompareAll,
	recommendedPlanId
}: PlanSelectionCardProps) => {
	return (
		<div className="flex flex-col gap-[24px] w-full p-[24px]">
			{/* Section heading */}
			<h2 className="font-grotesk font-medium text-[24px] leading-[30px] text-t-base-blue">
				Select protection plan
			</h2>

			{/* Plan Config: dropdowns + microcopy */}
			<PlanConfig
				adSpend={adSpend}
				onAdSpendChange={onAdSpendChange}
				selectedPlan={selectedPlan}
				plans={plans}
				onPlanChange={onPlanChange}
				onCompareAll={onCompareAll}
				recommendedPlanId={recommendedPlanId}
			/>

			{/* Plan Highlights */}
			<PlanHighlights
				selectedPlan={selectedPlan}
				features={selectedPlan.features}
			/>
		</div>
	)
}
